module.exports = __webpack_public_path__ + "static/carousel-2-0b90b9b33586f4ab4ffd850be6aa4399.png";